import React, { PropsWithChildren } from 'react';
import { Skeleton } from 'antd';
import './WithSkeleton.module.less';

type WithSkeletonProps = PropsWithChildren<{
  isLoading?: boolean;
}>;
const SkeletonLoader = <Skeleton active title paragraph={{ rows: 2 }} />;

const WithSkeleton = ({ children, isLoading }: WithSkeletonProps) => {
  return <>{!isLoading ? children : SkeletonLoader}</>;
};

export const SkeletonPageSet = () => (
  <>
    <Skeleton.Input active size="large" />
    <Skeleton active paragraph={{ rows: 4 }} />
    <Skeleton active paragraph={{ rows: 4 }} />
    <Skeleton title={{ width: 300 }} active paragraph={{ rows: 4 }} />
  </>
);

export default WithSkeleton;
